import type { QuestionModule } from "../contracts";
import {
  conjointCore,
  type ConjointRaw,
  type ConjointDefinition,
  type ConjointDraft,
  type ConjointEvent,
  type ConjointResponse,
} from "./core";
import { ConjointView } from "./views";

export const conjointModule: QuestionModule<
  ConjointRaw,
  ConjointDefinition,
  ConjointDraft,
  ConjointEvent,
  ConjointResponse
> = {
  type: "conjoint",
  galleryFeatures: [
    "baseline",
    "concepts",
    "attributes",
    "images",
    "option-images",
    "restored",
    "none",
    "dont-know",
    "disabled",
    "numeric-looking-ids",
  ],
  core: conjointCore,
  prompt: (definition) => ({
    content: definition.prompt,
    image: definition.image,
    altText: definition.altText,
    error: definition.error,
  }),
  views: {
    default: {
      id: "default",
      label: "Concepts",
      component: ConjointView,
      arrangements: ["compact", "wide"],
      requiredControls: [],
      space: "expanded",
      primaryActionOwner: "view",
    },
  },
  defaultDisplay: { view: "default" },
  controls: () => ({}),
};
